<template>
    <div>
        <div class="modal-header">
            <h2 class="text-center">Vil du afslutte opgaven?</h2>
        </div>

        <p class="text-center">Er du sikker på, at du vil afslutte opgaven?<br />Den forsvinder fra listen, og du skal klikke på "Afsluttede" for at finde den igen.</p>

        <div class="modal-footer">
            <div class="text-center modal-buttons">
                <button type="button" class="button-green" v-if="data.hasRequests" @click="setCloseTask(true)">Ja. Opgaven og henvendelser</button>
                <button type="button" class="button-green" v-if="data.hasRequests" @click="setCloseTask(false)"><span>Ja. Kun opgaven</span></button>
                <button type="button" class="button-green" v-if="!data.hasRequests" @click="setCloseTask(false)"><span>Ja</span></button>
                <button type="button" class="button-red" @click="closeModal()">Nej</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'task-modal-close',
    props: {
        data: Object
    },
    methods: {
        ...mapActions({
            closeTask: 'setTaskStatusClose'
        }),
        setCloseTask (closeRequests) {
            this.data.closeRequests = closeRequests
            new Promise((resolve, reject) => {
                resolve(this.closeTask(this.data))
            }).then((response) => {
                if (response.status === 200) {
                    if (response.data && response.data.taskClosed) {
                        this.$emit('close')
                        this.$nextTick(() => {
                            this.$router.push({
                                name: 'dashboard'
                            })
                        })
                    } else {
                        this.$notify({
                            group: 'info',
                            type: 'warn',
                            title: '',
                            text: response.data.closedMessage
                        })
                    }
                }
            })
        },
        closeModal () {
            this.$emit('close')
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/task/task-modal-close.vue